import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEnvelope, faUnlock } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from 'react-toastify';
import API from "../api/axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await API.post("/login", {
        email,
        password,
      });
      localStorage.setItem("token", response.data.client_token);
      localStorage.setItem("loginUser", JSON.stringify(response.data.user));
      toast.success("Login successfully");
      navigate("/submit-project");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="card shadow-sm p-4" style={{ maxWidth: "400px", width: "100%", borderRadius: "15px" }}>
        <h4 className="text-center fw-bold" style={{ color: "#6366f1" }}>Welcome back!</h4>
        <h5 className="text-center mb-4">Login to your account.</h5>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* Email */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Email</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
            <input
              type="email"
              className="form-control border-start-0"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        {/* Password */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Password</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <FontAwesomeIcon icon={faUnlock} />
            </span>
            <input
              type="password"
              className="form-control border-start-0"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>

        <button
          className="btn w-100 mb-3 d-flex align-items-center justify-content-center"
          style={{ background: "#111827", color: "white", fontWeight: "600", borderRadius: "8px" }}
          onClick={handleLogin}
        >
          Login
          <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
        </button>
      </div>
    </div>
  );
};

export default Login;
